import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faPhone } from "@fortawesome/free-solid-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

library.add(faInstagram, faPhone)

const Footer = () => (
  <footer className="footer has-background-grey-dark">
    <div className="columns align-text-top">
      <div className="column is-one-third">
        <p className="has-content-left has-text-white is-size-7-mobile">
          &copy; {new Date().getFullYear()} Klaus Architekten Innenarchitekten
          AG
        </p>
      </div>
      <div className="column">
        <p className="has-content-left has-text-white is-size-7-mobile">
          Rossauerstrasse 14
          <br />
          CH-8932 Mettmenstetten
        </p>
      </div>

      <div className="column">
        <p className="has-content-left has-text-white is-size-7-mobile">
          <span className="icon has-text-white">
            <FontAwesomeIcon
              icon={faPhone}
              size="1x"
              className="is-size-7-mobile"
            />
          </span>{" "}
          +41 44 767 13 12
          <br />
          mettmenstetten@klaus-architekten.ch
        </p>
      </div>
      <div className="column is-one-fifth has-text-left">
        <span className="icon">
          <a
            href="https://www.instagram.com/klaus_architekten/"
            target="_blank"
            rel="noreferrer"
            className="is-instagram has-text-grey-light"
            title="instagram"
          >
            <FontAwesomeIcon
              icon={["fab", "instagram"]}
              className="is-size-4-desktop is-size-5-mobile"
            />
          </a>
        </span>
      </div>
    </div>
  </footer>
)

export default Footer
